
import { ProjectHeader } from "@/components/projects/ProjectHeader";
import { InventoryLayout } from "@/components/inventory/InventoryLayout";
import { KitsManager } from "@/components/inventory/KitsManager";
import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useIsMobile } from "@/hooks/use-mobile";

export default function Inventory() {
  const [activeTab, setActiveTab] = useState("inventory");
  const isMobile = useIsMobile();

  return (
    <div className="min-h-screen premium-gradient">
      <div className="container mx-auto pt-4 px-4 pb-8 max-w-full">
        <div className="max-w-7xl mx-auto">
          <ProjectHeader />
          
          <Tabs 
            value={activeTab} 
            onValueChange={setActiveTab} 
            className="mt-6"
          >
            <TabsList className="w-full bg-background/40 backdrop-blur-sm border border-white/10 p-1 h-12 rounded-xl">
              <TabsTrigger 
                value="inventory" 
                className="flex-1 h-10 text-sm font-medium rounded-lg data-[state=active]:bg-white/20 data-[state=active]:text-white"
              >
                Inventory
              </TabsTrigger>
              <TabsTrigger 
                value="kits" 
                className="flex-1 h-10 text-sm font-medium rounded-lg data-[state=active]:bg-white/20 data-[state=active]:text-white"
              >
                Gear Kits
              </TabsTrigger>
            </TabsList>
            
            <TabsContent value="inventory" className="mt-6">
              <div className="mb-6">
                <h1 className="text-3xl font-bold mb-2 text-white tracking-tight">My Inventory</h1>
                <p className="text-white/70 text-base leading-relaxed">
                  Manage your equipment catalog and keep track of all your items
                </p>
              </div>
              <InventoryLayout />
            </TabsContent>
            
            <TabsContent value="kits" className="mt-6">
              <div className="mb-6">
                <h1 className="text-3xl font-bold mb-2 text-white tracking-tight">Gear Kits</h1>
                <p className="text-white/70 text-base leading-relaxed">
                  Create and manage reusable gear bundles
                </p>
              </div>
              <KitsManager />
            </TabsContent>
          </Tabs>
        </div>
      </div>
    </div>
  );
}
